<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    :fill="color"
    fill-rule="evenodd"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <defs>
      <path
        id="clock-path-1"
        d="M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 C14.418278,18 18,14.418278 18,10 C18,5.581722 14.418278,2 10,2 Z M10,5 L10,10 L14,10 L14,12 L8,12 L8,5 L10,5 Z"
      ></path>
    </defs>
    <g id="Icon-/-Clock" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Mask/LS_Green">
        <mask id="clock-mask-2" fill="white"><use xlink:href="#clock-path-1"></use></mask>
        <use id="Mask" :fill="color" xlink:href="#clock-path-1"></use>
        <g id="Rectangle" mask="url(#clock-mask-2)" :fill="color">
          <rect x="0" y="0" width="20" height="20"></rect>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'ClockSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
